import styled from "styled-components";

export const RodapeWrapper = styled.footer`
  width: 100%;
  background-color: ${props => props.fundo || "#1a1a2e"};
  color: ${props => props.texto || "#ffffff"};
`;

export const Zona1Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.colunas || 5}, 1fr);
  gap: 40px;
  padding: 48px 32px;
  max-width: 1440px;
  margin: 0 auto;


  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 32px 16px;
    gap: 32px;
  }
`;

export const LogoCol = styled.div`
  img {
    max-width: 140px;
    max-height: 60px;
    display: block;
  }

  .tagline {
    margin-top: 12px;
    font-size: 1.4rem;
    line-height: 1.5;
    opacity: 0.7;
  }
`;

export const GrupoCol = styled.div`
  h4 {
    font-size: 1.4rem;
    font-weight: 700;
    margin: 0 0 16px 0;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 8px;

      a {
        color: inherit;
        text-decoration: none;
        font-size: 1.4rem;
        opacity: 0.85;

        &:hover {
          text-decoration: underline;
          opacity: 1;
          color: ${props => props.theme.colors.primary};
        }
      }

      span {
        font-size: 1.4rem;
        opacity: 0.85;
      }
    }
  }
`;

export const Zona2Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .zonaContent {
    max-width: 1440px;
    margin: 0 auto;
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0px 32px;

    @media (max-width: 768px) {
      padding: 0px 16px;
    }
  }

  .copyright {
    font-size: 1.2rem;
    opacity: 0.8;
    text-align: left;
  }

  .pagamentos {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    .label {
      font-size: 1.2rem;
      opacity: 0.8;
    }
  }
`;

export const PagamentoChip = styled.span`
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 1.1rem;
`;

export const Zona3Legal = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 0px;

  .zonaContent {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
    padding: 0px 32px;

    @media (max-width: 768px) {
      padding: 0px 16px;
    }
  }

  .legal-text {
    font-size: 1.1rem;
    line-height: 1.6;
    opacity: 0.8;
    font-weight: normal;

    a {
      color: inherit;
      text-decoration: underline;

      &:hover {
        color: ${props => props.theme.colors.primary};
      }
    }
  }

  .anvisa-row {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
    }

    .selos {
      display: flex;
      align-items: center;
      gap: 12px;
      list-style: none;
      margin: 0;
      padding: 0;

      img {
        height: 35 px;
      }
    }

    a {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: inherit;
      text-decoration: none;
      font-size: 1.1rem;

      &:hover {
        color: ${props => props.theme.colors.primary};
      }

      img {
        height: 28px;
      }
    }
  }
`;
